import Country from "./Country";
import Currency from "./Currency";
import { UnitOfMeasurement } from "./UnitOfMeasurement";

export interface Service {
    id?: number;
    name: string;
    code: string;
    sku: string;
    statusId: number;
    serviceTypeId: number;
    serviceType: ServiceType;
    servicePrices: ServicePrice[];
    serviceStatus: ServiceStatus;
    productVariants: ServiceProductVariant[];
    vendorId?: number;
    businessUnitId?: number;
}

export const emptyService = {
    id: 0,
    name: '',
    code: '',
    sku: '',
    publishStatusId: 0,
    serviceTypeId: 0,
    serviceType: {
        id: 0,
        code: '',
        name: ''
    },
    servicePrices: [],
    products: [],
    vendorId: 0
}

export interface ServiceProductVariant {
    id: number;
    sku: string;
    productName: string;
    quantity: number;
    isOptional: boolean;
    status: string;
    [key: string]: any;
}

export interface VariantSKUForm {
    isOptional: boolean;
    quantity: number;
}

export interface ServiceType {
    id: number;
    code: string;
    name: string;
}

export interface ServiceStatus {
    id: number;
    code: string;
    name: string;
}

export interface ServicePrice {
    id: number;
    serviceId: number;
    pricePerUnit: number;
    itemsPerUnit: number;
    currencyId: number;
    countryId: number;
    type: string;
    unitOfMeasurement: UnitOfMeasurement;
    country?: Country;
    currency?: Currency;
    unitOfMeasurementId?: number;
}
export interface IFormData {
    id?: number | null;
    name: string;
    code?: string;
    sku: string;
    statusId?: number;
    serviceTypeId?: number;
    unitOfMeasurementUsaId?: number | null;
    unitOfMeasurementCaId?: number | null;
    isForCanada?: boolean;
    isForUSA?: boolean;
    canadaPrice?: string | null;
    usaPrice?: string | null;
    vendorId?: number;
    businessUnitId?: number;
    version: number;
    productVariants: ServiceProductVariant[];
    servicePrices?: ServicePrice[];
    isOptional?: boolean;
}

export interface ServiceProducts {
    productVariants: ServiceProductVariant[];
    invalidSkus: string[];
}

export type UploadingStatus = {
    statusId: number,
    fileName: string,
    passedCount: number,
    failedCount: number,
    totalCount: number,
    createdOn: string,
    originalFileLocation?: string,
    validatedFileLocation?: string
}

export interface ProductAddonPreview {
    id: number;
    entryNumber: number;
    parentEntryNumber: number;
    productId: string;
    productSKU: string;
    productName: string;
    quantity: number;
    basePrice: number;
    totalPrice: number;
    plannedUsage: number;
    requiredAddon: boolean;
    unit: {
        id: number;
        code: string;
    };
    serialNumber: string;
    addonId?: number;
    error?: string[];
}

export interface IProductAddonForm {
    sku: string;
    quantity: number;
}

export const emptyProductAddon: IProductAddonForm = {
    sku: '',
    quantity: 0
}